import { REACT_APP_API } from '../../config'
import axios from 'axios'
import { generateErrorObject } from 'common/utils/generateErrorObject'

export const getRequestFailedToastMessage = (error) => {
    return `Request failed with status code ${error.statusCode}`
}

export async function getNotifications(userId, page = 1, unreadOnly = false, section = null, eventReason = null) {
    try {
        const sectionParam = section ? `&section=${section}` : ''
        const eventReasonParam = eventReason ? `&eventReason=${eventReason}` : ''
        const response = await axios.get(
            `${REACT_APP_API}/notifications/user/${userId}?page=${page}&unreadOnly=${unreadOnly}${sectionParam}${eventReasonParam}`
        )
        const { notifications, totalRead, totalUnread } = response.data // Asegúrate de que el backend devuelva ambas propiedades
        return { notifications, totalRead, totalUnread } // Devuelve tanto las notificaciones como el total de no leídas
    } catch (error) {
        throw generateErrorObject(error)
    }
}

export async function markAsRead(notificationId, userId) {
    try {
        const response = await axios.post(
            `${REACT_APP_API}/notifications/read?action=read`,
            {
                notification_id: notificationId,
                user_id: userId
            }
        )

        if (response.status !== 200) {
            throw new Error('Error al marcar la notificación como leída')
        }

        return response.data
    } catch (error) {
        console.error('Error en la solicitud al BFF:', error.message)
        throw error
    }
}

export async function markAsUnread(notificationId, userId) {
    try {
        const response = await axios.post(
            `${REACT_APP_API}/notifications/read?action=unread`,
            {
                notification_id: notificationId,
                user_id: userId
            }
        )

        if (response.status !== 200) {
            throw new Error('Error al marcar la notificación como no leída')
        }

        return response.data
    } catch (error) {
        console.error('Error en la solicitud al BFF:', error.message)
        throw error
    }
}
